import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { EntityAlertModel } from './models/entity-alert.model';

export interface AlertState extends EntityState<EntityAlertModel> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'alert', idKey: 'AlertId', cache: { ttl: 30000 } })
export class AlertStore extends EntityStore<AlertState> {
  constructor() {
    super({});
  }
}
